// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"607d24ff","667":"0e0fa377"}[chunkId] + ".chunk.js";
};